var alertNotifications = {
	alert: {
		limitAbove: "Oberes Limit überschritten",
		limitBelow: "Unteres Limit überschritten"
	},
	closeBtn: "Schließen",
	openHistory: "Alertverlauf öffnen"
};
var de = {
	alertNotifications: alertNotifications
};

export { alertNotifications, de as default };
